export default __webpack_public_path__ + "static/media/myriam.8529a11c.webp";